import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ROUTES } from '../constants';
import { LoginForm } from '../components/forms';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Get the intended destination from location state
  const from = location.state?.from?.pathname || ROUTES.MARKETERS;

  // If already authenticated, redirect to intended destination
  if (isAuthenticated) {
    return <Navigate to={from} replace />;
  }

  // Handle successful login
  const handleLoginSuccess = result => {
    // The AuthContext will handle the redirect automatically
    // This callback can be used for additional actions if needed
    console.log('Login successful:', result);
  };

  return <LoginForm onSuccess={handleLoginSuccess} />;
};

export default LoginPage;
